import { redirect } from "@tanstack/react-router";
import { fetchQuery, graphql } from "relay-runtime";
import type { AppRouterContext } from "~/router";
import type { onboardingOneDeliveryGateQuery } from "./__generated__/onboardingOneDeliveryGateQuery.graphql";

/** Pay-per-use price per bundle in euro cents (Figma "OD - Order Step 1 - Pricing"). */
export const PAY_PER_USE_PRICE_CENTS = 299;

export const ONBOARDING_STEPS = 7;

const gateQuery = graphql`
	query onboardingOneDeliveryGateQuery {
		onedeliveryProfile {
			onboardedAt
		}
	}
`;

/**
 * Route loader guard: users who have not accepted the One Delivery terms (`onboardedAt`, set by
 * the onboarding summary) are sent to the onboarding.
 */
export async function requireOnboarded(environment: AppRouterContext["relayEnvironment"]) {
	const data = await fetchQuery<onboardingOneDeliveryGateQuery>(environment, gateQuery, {}, { fetchPolicy: "network-only" }).toPromise();
	if (!data?.onedeliveryProfile?.onboardedAt) throw redirect({ to: "/one-delivery/onboarding" });
}
